import { useLang } from '../i18n';

const PHONE_HREF = 'tel:+18059229684';

function MedalIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="6"/><path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12"/>
    </svg>
  );
}

export default function MilitaryBand() {
  const { t } = useLang();

  return (
    <section className="military-band" data-testid="military-band">
      <div className="military-inner">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem' }}>
          <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(255,255,255,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0 }}>
            <MedalIcon />
          </div>
          <div className="military-text">
            <h2>{t.milTitle}</h2>
            <p>{t.milBody}</p>
          </div>
        </div>
        <a href={PHONE_HREF} className="btn-military" data-testid="military-discount-cta" aria-label="Call about military discount">
          {t.milCta}
        </a>
      </div>
    </section>
  );
}
